<script>
import { Component, Vue } from 'vue-property-decorator'
import { QCard, QCardSection, QCardActions, QBtn, QIcon } from 'quasar'
@Component({
  name: 'confirmation-modal',
  components: {
    QCard,
    QCardSection,
    QIcon
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    mode: {
      type: String,
      default: 'approve',
      validator: value => ['approve', 'deny'].includes(value)
    },
    title: {
      type: String,
      default: ''
    },
    closeOnOverlay: {
      type: Boolean,
      default: true
    }
  }
})

export default class ConfirmationModal extends Vue {
  observation = '';

  onApprove () {
    this.$emit('approve')
    this.$emit('close')
  }

  onDeny () {
    this.$emit('deny', this.observation)
    this.observation = ''
    this.$emit('close')
  }

  onCancel () {
    this.observation = ''
    this.$emit('close')
  }

  setTitle (mode) {
    return this.title || (mode === 'approve' ? this.$gettext('APPROVAL_INVOICE_SETTLEMENT_MSG_CONFIRM') : this.$gettext('DENY_INVOICE_SETTLEMENT_MSG_CONFIRM'))
  }
}
</script>

<template>
  <div>
    <q-dialog v-model="visible" persistent>
      <q-card class="modal-card">
        <q-card-section class="row justify-center q-pt-lg">
          <q-icon
            :name="mode === 'approve' ? 'check_circle' : 'error_outline'"
            :color="mode === 'approve' ? 'positive' : 'warning'"
            size="5em"
          ></q-icon>
        </q-card-section>

        <q-card-section class="row justify-center q-mx-xl">
            <span class="text-h6 text-weight-medium text-center">
              {{ setTitle(mode) }}
            </span>
        </q-card-section>

        <q-card-section v-if="mode === 'deny'" class="q-pt-none q-px-lg">
          <q-input
            v-model="observation"
            type="textarea"
            :label="$gettext('REASON')"
            outlined
            class="full-width textarea-fixed-height"
            rows="4"
            maxlength="500"
            counter
          />
        </q-card-section>

        <q-card-actions class="justify-center q-pa-lg q-my-md">
          <q-btn
            :label="$gettext('CANCEL')"
            color="grey-7"
            v-close-popup
            @click="onCancel"
            class="q-px-xl q-py-sm text-weight-medium"
            size="md"
          />
          <q-btn
            v-if="mode === 'approve'"
            :label="$gettext('APPROVE')"
            color="positive"
            @click="onApprove"
            class="q-px-xl q-py-sm text-weight-medium q-ml-md"
            size="md"
          />
          <q-btn
            v-else
            :label="$gettext('REJECT')"
            color="negative"
            @click="onDeny"
            class="q-px-xl q-py-sm text-weight-medium q-ml-md"
            size="md"
            :disable="!observation.trim()"
          />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </div>
</template>

<style scoped>
.modal-card {
  position: fixed;
  top: 50%;
  left: 50%;
  z-index: 9999;
  transform: translate(-50%, -50%);
  width: 500px;
  max-width: 90vw;
}

.textarea-fixed-height textarea {
  min-height: 130px !important;
  resize: none;
}

/* Para telas menores */
@media (max-width: 599px) {
  .modal-card {
    width: 90vw;
  }
}
</style>
